var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "toolbar-slide" } }, [
    _vm.isToolbarVisible
      ? _c("div", { staticClass: "activities-toolbar-container" }, [
          _c(
            "div",
            { staticClass: "activities-toolbar" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "typographies-paragraph-medium-bold btn-cancel-selected-items"
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close", variant: "contrast" },
                    on: { click: _vm.closeToolbar }
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.selectedActivitiesCount) +
                      "\n                " +
                      _vm._s(
                        _vm.selectedActivitiesCount === 1
                          ? _vm.$t.__("common.labels.selected_singular")
                          : _vm.$t.__("common.labels.selected_plural")
                      ) +
                      "\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.finish"),
                  type: "tertiary-contrast",
                  leftIcon: "success-circle"
                },
                on: { click: _vm.handleOpenMarkAssDone }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.reschedule"),
                  type: "tertiary-contrast",
                  leftIcon: "calendar-reschedule"
                },
                on: { click: _vm.handleRescheduleModal }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "activities.listing.massActions.ActivitiesListingMassActions.modify_owner"
                  ),
                  type: "tertiary-contrast",
                  leftIcon: "user-fill"
                },
                on: { click: _vm.handleAssignOwnerModal }
              }),
              _vm._v(" "),
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    disabled: !_vm.areOnlyPhonecallsSelected,
                    content: _vm.$t.__(
                      "activities.listing.massActions.ActivitiesListingMassActions.tooltip_disabled_assign_button"
                    ),
                    placement: "top"
                  }
                },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.assign"),
                      type: "tertiary-contrast",
                      leftIcon: "user-fill",
                      disabled: _vm.areOnlyPhonecallsSelected
                    },
                    on: { click: _vm.handleAssignModal }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.delete"),
                  type: "tertiary-contrast",
                  leftIcon: "bin"
                },
                on: { click: _vm.handleDeleteModal }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }